<template>
  <div class="tag-manage page-card">
    <div class="d-flex between">
      <div class="left d-flex">
        <div class="d-flex mr10">
          <!-- 标签名称： -->
          <label class="mr5">标签名称</label>
          <el-input class="custom-input" v-model="queryParams.name" :placeholder="`请输入`"></el-input>
        </div>

        <div v-if="user.is_super_tenant_admin" class="d-flex mr10">
          <label class="mr5">租户名称</label>
          <tenantSelection @clickTenant="getTenantInfo" :data="tenantData" @inputClear="inputClear"></tenantSelection>

          <!-- <el-cascader
            :before-filter="remoteSearch"
            filterable
            :options="address"
            :show-all-levels="false"
            clearable
            v-model="queryParams.tenant_id"
            :props="{
              label: 'name',
              value: 'code',
              emitPath:false
            }"
            popper-class="cascader-style"
            @expand-change="expandChange"
            >
          </el-cascader> -->
          <!-- <el-select
            class="input200"
            v-model="queryParams.tenant_id"
            remote
            filterable
            clearable
            :remote-method="getTenantsOpts"
            @focus="getTenantsOpts()"
          >
            <el-option
              v-for="item in tenantOpts"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select> -->
        </div>

        <!-- 标签尺寸 -->
        <div class="d-flex mr10">
          <label class="mr5">标签尺寸</label>
          <el-select
            class="input200"
            v-model="queryParams.size_alias"
            remote
            filterable
            clearable
            :remote-method="getSizeOpts"
            @focus="getSizeOpts()"
          >
            <el-option
              v-for="item in sizeOpts"
              :key="item.size_alias"
              :label="item.size_alias"
              :value="item.size_alias">
            </el-option>
          </el-select>
        </div>

        <!-- 查询 -->
        <el-button
          icon="el-icon-search"
          class="ml20"
          type="primary" 
          size="mini" 
          @click="search">查询</el-button>
        <!-- 新建 -->
        <el-button
          v-if="user.is_super_tenant_admin"
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="create()"
        >新建</el-button>
        <!-- 导入 -->
        <el-button
          v-if="btnauth[$route.path].includes('tag_template_import')"
          type="primary"
          icon="el-icon-upload2"
          size="mini"
          @click="importTag()"
        >导入</el-button>
      </div>
    </div>

    <el-table
      border
      class="mt10"
      :data="list"
      align="center"
      :auto-resize="true"
      :row-style="rowStyle"
      >
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeaders"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        :width="item.width"
        :class-name="`col-${item.prop}`"
      >
          <template slot-scope="scope">
            <span v-if="item.prop === 'handle'">
              <!-- 打印 -->
              <el-button
                v-if="user.ins_tenant_id === 0 || user.ins_tenant_id === user.tenant_id"
                :disabled="scope.row.is_delete == 1"
                type="text"
                size="mini"
                @click="print(scope.row)"
              >打印</el-button>
              <!-- 复制 -->
              <el-button
                v-if="user.is_super_tenant_admin"
                :disabled="scope.row.is_delete == 1"
                type="text"
                size="mini"
                @click="copy(scope.row)"
              >复制</el-button>
              <!-- 编辑 -->
              <el-button
                v-if="user.is_super_tenant_admin || user.role_id == 2"
                :disabled="scope.row.is_delete == 1"
                type="text"
                size="mini"
                @click="edit(scope.row)"
              >编辑</el-button>
              <!-- 删除 -->
              <el-button
                v-if="user.is_super_tenant_admin || user.role_id == 2"
                :disabled="scope.row.is_delete == 1"
                type="text"
                size="mini"
                @click="del(scope.row)"
              >{{ delBtnText }}</el-button>
              <!-- 预览 -->
              <el-button
                type="text"
                size="mini"
                @click="printTest(scope.row)"
              >预览</el-button>
              <!-- 发送 -->
              <el-button
                v-if="user.is_super_tenant_admin"
                :disabled="scope.row.is_delete == 1"
                type="text"
                size="mini"
                @click="sendToTenant(scope.row)"
              >发送到租户</el-button>
              <!-- 导出 -->
              <el-button
                v-if="btnauth[$route.path].includes('tag_template_export')"
                type="text"
                size="mini"
                @click="exportFile(scope.row)"
              >导出</el-button>
            </span>
            <span v-else>{{scope.row[item.prop]}}</span>
          </template>
      </el-table-column>
    </el-table>

    <pagination :queryParams="queryParams" :getList="getList" />

    <!-- 文件导入 -->
    <file-reader ref="FileReader" :limit="1" @complete="getReadFile" />

    <!-- 预览标签iframe -->
    <frame ref="frame" />

    <!-- 发送到租户 -->
    <SendToTenant ref="SendToTenant" @refresh="getList" />
  </div>
</template>

<script>
import tenantSelection from '@/components/common/tenantSelection'
import { mapGetters } from 'vuex'
import { pageSize } from '@/utils/Config.js'
import tagMixin from '@/mixins/tag'
import { tagManage, tagManageList, tagManageCopy, tagManageDelete, tagSetDefault, getTenantOpts, tagSizeOptions } from '@/api'
import Pagination from '@/components/common/Pagination'
import FileReader from '@/components/common/FileReader.vue'
import Frame from '@/components/common/Frame'
import SendToTenant from '../components/sendToTenant.vue'
export default {
  name: 'TagManagePage',
  mixins: [ tagMixin ],
  components: { Pagination, FileReader, Frame, SendToTenant,tenantSelection },
  computed: {
    ...mapGetters(['user', 'btnauth','addressOptions']),
    delBtnText() {
      let text = '';
      if (this.user.role_id === 1) {
        text = `禁用`
      } else if (this.user.role_id === 2) {
        text = `删除`
      }

      return text
    },
    // address(){
    //   // 区县下一级列表初始化
    //   let arr = this.$utils.deepCopy(this.addressOptions)
    //               // 避免重复做处理
    //               for (const item of arr) {
    //     item.code = item.code + 'code'
    //   }
    //   for (const province of arr) {
    //     for (const city of province.children) {
    //       for (const county of city.children) {
    //         this.$set(county,'children',[])
    //       }
    //     }
    //   }
    //   this.tenantOpts.forEach(item => {
    //     const province = arr.find(i => i.code === item.province + 'code')
    //     if (province) {
    //       const city = province.children.find(i => i.code === item.city)
    //       if (city) {
    //         const county = city.children.find(i => i.code === item.area)
    //         if (county) {
    //           county.children.push({
    //             name: item.name,
    //             code: item.id
    //           })
    //         }
    //       }
    //     }
    //   })
    //   return arr
    // }
  },
  data() {
    return {
      // statues: [
      //   {
      //     // 全部
      //     name: `全部`,
      //     value: undefined
      //   },
      //   {
      //     // 启用
      //     name: `启用`,
      //     value: 1
      //   },
      //   {
      //     // 关闭
      //     name: `关闭`,
      //     value: 0
      //   },
      // ],
      queryParams: {
        pageIndex: 1,
        pageSize,
        _total: 0,
      },
      tableHeaders: [],
      list: [],
      tenantOpts: [],
      sizeOpts: [],
      tenantData:{
        inputData:'',
        clearable:true
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 从子组件获取信息
    getTenantInfo(data){
      this.queryParams.tenant_id = data.id
      this.tenantData.inputData = data.name
    },
    // 当子组件清除内容时
    inputClear(){
      this.queryParams.tenant_id = ''
    },
    rowStyle({ row }) {
      let rowColor = '';
      const { is_del_belong } = row;
      switch (is_del_belong) {
        case 1:
          rowColor = 'lightgray';
          break;

        case 2:
          rowColor = 'yellow';
          break;
      }

      return rowColor ? { backgroundColor: rowColor } : {}
    },
    getList() {
      const {
        name,
        status,
        pageSize,
        pageIndex,
        tenant_id,
        size_alias
      } = this.queryParams

      const query = {
        name,
        status,
        page: pageIndex,
        per_page: pageSize,
        tenant_id,
        size_alias: size_alias || undefined
      }

      this.$request('get', tagManageList, query)
      .then(res => {
        if (res) {
          this.list = res.data
          this.tableHeaders = this.$utils.generateColumns(res.columns)
          this.queryParams._total = res.total
        }
      })
    },
    // getTenantsOpts(name = null , area = null , province = null , city = null) {
    //   return this.$request('get', getTenantOpts, { name,province,city,area })
    //   .then(res => {
    //     this.tenantOpts = res || []
    //   })
    // },
    // defaultChange(item) {
    //   const { id } = item
    //   this.$request('post', tagSetDefault, { id })
    //   .then(res => {
    //     if (res) {
    //       this.$message.success(`操作成功`)

    //       this.getList()
    //     }
    //   })
    // },
    getSizeOpts(size_alias){
      // 获取标签尺寸筛选项
      return this.$request('get', tagSizeOptions, { size_alias })
      .then(res => {
        this.sizeOpts = res || []
      })
    },

    search() {
      this.queryParams.pageIndex = 1

      this.getList()
    },
    copy(item) {
      const { id } = item

      this.$request('get', tagManageCopy, { id } )
      .then(res => {
        if (res) {
          // 操作成功
          this.$message.success(`操作成功`)

          this.getList()
        }
      })
    },
    edit(item) {
      const { id } = item

      this.$router.push(`/tag/template/index/${id}`)
    },
    create() {
      this.$router.push(`/tag/template/index/0`)
    },
    importTag() {
      const { FileReader } = this.$refs

      FileReader && FileReader.show()
    },
    async del(item) {
      const msg = this.user.role_id === 1
      ? `确定禁用吗？` : `确认删除吗?`
      const confirm = await this.$utils.confirm({
        msg
      })
      if (!confirm) return 
      const { id } = item

      this.$request('post', tagManageDelete, { ids: [id] })
      .then(res => {
        if (res) {
          // 操作成功
          this.$message.success(`操作成功`)

          this.getList()
        }
      })
    },
    async printTest(item) {
      const { id, tenant_id } = item
      const detail = await this._getSmartTagDetail(id)
      const printData = this._parseSmartTagConfigByDetail(detail)
      
      // 如果有logo时处理
      const { tag: tagData } = printData
      let { content } = tagData
      content = await this._setLogoByData(content, tenant_id)
      printData.tag.content = content

      const elementString = this._generatePrintHtml(printData, {ins_code: [{}], batch_list: [{}]})
      const {
        tag
      } = printData
      if (!tag || !tag.w) return
      const size = `${tag.w}x${tag.h}`

      this.$refs.frame.open(elementString, size)
    },
    sendToTenant(item) {
      // 发送到租户
      const {
        id
      } = item
      const {
        SendToTenant
      } = this.$refs

      SendToTenant && SendToTenant.open(id)
    },
    print(item) {
      const {
        id
      } = item
      
      this.$router.push(`/tag/print/index/${id}`)
    },
    async exportFile(item) {
      // 导出文件
      const { id } = item
      const detail = await this._getSmartTagDetail(id)
      const { content, size, name, remark } = detail
      const contentData = {
        content,
        size,
        name,
        remark,
        status: 0
      }

      const exportData = {
        content: JSON.stringify(contentData),
        fileName: `${name}.json`,
        type: 'application/json'
      }

      this.$utils.saveAsFile(exportData)
    },
    getReadFile(files) {
      // 获取读取文件
      const file = files[0]
      if (file) {
        try {
          const {
            name,
            result
          } = file
          const content = JSON.parse(result)
          const nameArray = name.split('.')
          nameArray.pop()
          const fileName = nameArray.join('.')
          
          this.save(content, fileName)
        } catch (error) {
          console.error('解析文件出错:', error)
        }
      }
    },
    save(contentData, fileName) {
      // 保存数据
      const {
        content,
        size
      } = contentData
      const params = {
        content,
        name: fileName,
        remark: '',
        status: 0,
        size
      }

      this.$request('post', tagManage, params)
      .then(res => {
        if (res) {
          // 保存成功
          this.$message.success(`保存成功`)

          this.getList()
        }
      })
    },
    async remoteSearch(value){
      let res = await this.$request('get', getTenantOpts, { name:value })
      this.tenantOpts = res || []
    },
    // expandChange(node){
    //   if (node[2]) {
    //     this.getTenantsOpts(null,node[2])
    //   }
    // }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/css/common.scss';
  .col-handle {
    button {
      margin: 4px !important;
    }
  }
</style>